import { useLocation } from 'react-router-dom';
import { TabsContainer } from '@/components/TabView/Tabs';

export default function SearchTabView() {

  const items = [
    {
      label: 'All',
      value: 'all',
      to: 'all',
    },
    {
      label: 'Projects',
      value: 'projects',
      to: 'projects',
    },
    {
      label: 'Transcripts',
      value: 'transcripts',
      to: 'transcripts',
    },
    {
      label: 'Files',
      value: 'files',
      to: 'files',
    },
    {
      label: 'Folders',
      value: 'folders',
      to: 'folders',
    },
    {
      label: 'Brands',
      value: 'brands',
      to: 'brands',
    },
    {
      label: 'Dashboards',
      value: 'dashboards',
      to: 'dashboards',
    },
    {
      label: 'Analysis',
      value: 'quantanalyses',
      to: 'quantanalyses',
    },
  ];

  const location = useLocation();

  const currentTab = [
    'all',
    'files',
    'folders',
    'brands',
    'dashboards',
    'quantanalyses',
    'transcripts',
    'projects',
  ].find(tab => location.pathname.endsWith(`/${tab}`)) || 'all';

  return (
    <TabsContainer items={items} currentTab={currentTab} />
  );
}

export { SearchTabView };